import camelCase from 'lodash/camelCase';
import cloneDeep from 'lodash/cloneDeep';
import isPlainObject from 'lodash/isPlainObject';
import map from 'lodash/map';
import mapKeys from 'lodash/mapKeys';
import mapValues from 'lodash/mapValues';
import snakeCase from 'lodash/snakeCase';
import { sanitizeFileName } from 'utils';

class Utils {
  public static buildUrl = (path: string, params?: string[]): string => {
    let urlPath = path;
    // If params are provided, replace each parameter in the path
    if (params && params.length > 0) {
      params.forEach((param) => {
        // Replace the first occurrence of ':param' in the path
        urlPath = urlPath.replace(/:\w+/, param);
      });
    }

    return `${window.location.protocol}//${window.location.host}${urlPath}`;
  };

  public static exportToJson = (json: object, fileName: string) => {
    const link = document.createElement('a');
    link.href = `data:text/json;chatset=utf-8,${encodeURIComponent(JSON.stringify(json, null, 2))}`;
    link.download = sanitizeFileName(`${fileName}.json`);
    link.click();
  };

  public static isMobileTouchDevice = () => navigator.maxTouchPoints > 0 && /\b(iPad|iPhone|iPod|Android|Mobi|Mobile)\b/.test(navigator.userAgent);

  public static keysToCamelCase = (elem: any): any => {
    if (isPlainObject(elem)) {
      let camelCaseObject = cloneDeep(elem);
      // Convert keys to camel case
      camelCaseObject = mapKeys(camelCaseObject, (_value, key) => camelCase(key));
      // Recursively apply throughout object
      return mapValues(camelCaseObject, this.keysToCamelCase);
    }
    if (Array.isArray(elem)) {
      return map(elem, this.keysToCamelCase);
    }
    return elem;
  };

  public static keysToSnakeCase = (elem: any): any => {
    if (isPlainObject(elem)) {
      let snakeCaseObject = cloneDeep(elem);
      // Convert keys to snake case
      snakeCaseObject = mapKeys(snakeCaseObject, (_value, key) => snakeCase(key));
      // Recursively apply throughout object
      return mapValues(snakeCaseObject, this.keysToSnakeCase);
    }
    if (Array.isArray(elem)) {
      return map(elem, this.keysToSnakeCase);
    }
    return elem;
  };

  public static snakeCaseKey = (key: string): string =>
    key
      .split('.')
      .map((k) => snakeCase(k))
      .join('.');

  public static camelCaseKey = (key: string): string =>
    key
      .split('.')
      .map((k) => camelCase(k))
      .join('.');
}

export default Utils;
